import React, { ReactNode } from "react";
import { Alert, Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../../assets/logo-gw.svg";
import classNames from "classnames";

const logoHeight = "30px";

export interface HeaderProps {
  /**
   * Titel der Anwendung, entweder als Text oder auch als JSX um zB Formatierungen zu ermöglichen
   * */
  title: string | ReactNode;
  /**
   * Optionaler Link, zu dem navigiert werden soll, wenn man auf den Titel klickt. Es muss dabei ein lokaler Link sein. Wird kein Link angegeben, dann wird auf "/" gezeigt.
   */
  titleLinkUrl?: string;
  /**
   * Optionale URL für ein Logo, welches neben dem Titel (also als Brand) angezeigt werden soll
   */
  titleLogoSrc?: string;
  /**
   * Soll kein Logo angezeigt werden?
   */
  noLogo?: boolean;
  /**
   * Optionale URL für ein Logo, welches angezeigt werden soll.
   */
  logoSrc?: string;
  /**
   * Soll das Logo *nicht* mit einem weißen Hintergrund versehen werden (weil das Logo zB transparent ist)?
   */
  noWhiteBackground?: boolean;
  /**
   * Name der aktuellen Umgebung. Dies wird im Header angezeigt, wenn gesetzt.
   */
  environment?: string;
}

/**
 * Kopfzeile der Anwendung
 */
export const Header: React.FC<HeaderProps> = ({
  title,
  titleLinkUrl = "/",
  titleLogoSrc,
  noLogo = false,
  noWhiteBackground = false,
  logoSrc,
  children,
  environment,
}: React.PropsWithChildren<HeaderProps>) => {
  const logoClasses = classNames(
    {
      "bg-white": !noWhiteBackground,
    },
    "p-1 d-none d-sm-inline"
  );
  const imgClasses = "d-inline-block align-top";

  return (
    <header>
      <Navbar expand="md" collapseOnSelect bg="gradient" variant="dark" className="justify-content-between">
        <Navbar.Brand as={Link} to={titleLinkUrl} className="ml-2 pr-2 flex-fill">
          {titleLogoSrc && (
            <>
              <img
                src={titleLogoSrc}
                height={logoHeight}
                className={imgClasses}
              />{" "}
            </>
          )}
          {title}
        </Navbar.Brand>
        {children && <Navbar.Toggle aria-controls="top-navbar" />}

        {environment && (
          <Alert variant="warning" style={{padding: "0.25rem", margin:"0"}}>
            <div className="font-weight-bold">
              Umgebung: {environment.toUpperCase()}
            </div>
          </Alert>
        )}

        <Navbar.Collapse id="top-navbar" className="justify-content-end">
          {!noLogo && (
            <Navbar.Text className={logoClasses}>
              {logoSrc ? (
                <img src={logoSrc} height={logoHeight} />
              ) : (
                <Logo height={logoHeight} />
              )}
            </Navbar.Text>
          )}
          {children && <Nav>{children}</Nav>}
        </Navbar.Collapse>
      </Navbar>
    </header>
  );
};
